<template>
  <div class="modal-backdrop" @click.self="close">
    <div class="modal-content">
      <h3>Informações da Tarefa</h3>
      <div>
        <p><strong>Nome:</strong> {{ tarefa?.nome || "N/A" }}</p>
        <p><strong>Descrição:</strong> {{ tarefa?.descricao || "N/A" }}</p>
        <p><strong>Data:</strong> {{ formattedDate }}</p>
        <p><strong>Status:</strong> {{ tarefa?.status || "N/A" }}</p>
        <p><strong>Data de Previsão:</strong> {{ previsaoFormattedDate || "N/A" }}</p>
      </div>
      <div class="buttons">
        <button type="button" @click="close">Fechar</button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineEmits, defineProps, computed } from "vue";

const props = defineProps({
  colaboradores: {
    type: Array,
    required: true,
  },
  tarefa: {
    type: Object,
    required: true,
  },
});

const emit = defineEmits("close");

const formattedDate = computed(() => {
  if (!props.tarefa) return "N/A";
  const dateStr = props.tarefa.created_at || props.tarefa.data_criacao || null;
  if (!dateStr) return "N/A";
  const date = new Date(dateStr);
  if (isNaN(date.getTime())) return "N/A";
  return date.toLocaleDateString("pt-BR");
});

const previsaoFormattedDate = computed(() => {
  if (!props.tarefa) return "N/A";
  const dateStr = props.tarefa.data_previsao || props.tarefa.created_at || null;
  if (!dateStr) return "N/A";
  const date = new Date(dateStr);
  if (isNaN(date.getTime())) return "N/A";

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();

  return `${day}/${month}/${year}`;
});

function close() {
  emit("close");
}
</script>

<style scoped>
.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.modal-content {
  background: white;
  width: 70vw;
  padding: 1rem;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
}

.modal-content h3 {
  margin-top: 0;
  margin-bottom: 1rem;
  font-weight: 600;
}

.buttons {
  margin-top: 1rem;
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
}

.buttons button {
  padding: 0.4rem 0.8rem;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  background-color: #56008f;
  color: white;
}
</style>
